// src/components/AuthActivity/RiskFlag/RiskFlag.js

import React from "react";
import { TriangleAlert } from "lucide-react";
import "./RiskFlag.css";

const RiskFlag = ({ label }) => (
  <span className="risk-flag">
    <TriangleAlert size={12} className="risk-flag__icon" />
    {label}
  </span>
);

export default RiskFlag;